// src/App.js

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/Login';
import RegisterPage from './pages/RegisterNormal';
import CompanyRegisterPage from './pages/CompanyRegister';
import DashboardCalendar from './pages/CompanyPages/Dashboard';
import ProtectedRoute from './Services/ProtectedRoute';
import ManageSectors from './pages/CompanyPages/SectorManager';
import ManageServices from './pages/CompanyPages/ServicesManager';
import CompanySettings from './pages/CompanyPages/Settings';
import NotFoundPage from './pages/NotFound';
import UnauthorizedPage from './pages/Unauthorized';
import CreateAppointment from './pages/CompanyPages/CreateAppointment';
import UserMainPage from './pages/UserPages/MainPage';
import ServicePage from './pages/UserPages/ServicePage';
import UserAppointmentsPage from './pages/UserPages/UserAppointmentsPage';
import AppointmentLogsPage from './pages/CompanyPages/AppointmentsLogs';
import TermsPage from './pages/Terms';
import NotFound from './components/NotFound'; // Componente de página 404 personalizado
import ReschedulePage from './pages/CompanyPages/Reschedule';
import ManageCompanies from './pages/CompanyPages/CompanyManager';
import UserSettings from './pages/UserPages/UserSettings';
import ManageEmployees from './pages/CompanyPages/ManageEmployees';

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Navigate to="/user/home" replace />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/register-company" element={<CompanyRegisterPage />} />
        <Route path="/terms" element={<TermsPage />} />
        
        {/* Rotas Protegidas para Empresa */}
        <Route path="/company-dashboard/:companyId" element={<ProtectedRoute><DashboardCalendar /></ProtectedRoute>} />
        <Route path="/create-sector/:companyId" element={<ProtectedRoute><ManageSectors /></ProtectedRoute>} />
        <Route path="/create-service/:companyId" element={<ProtectedRoute><ManageServices /></ProtectedRoute>} />
        <Route path="/company-settings/:companyId" element={<ProtectedRoute><CompanySettings /></ProtectedRoute>} />
        <Route path="/create-appointment/:companyId" element={<ProtectedRoute><CreateAppointment /></ProtectedRoute>} />
        <Route path="/company-appointments/:companyId" element={<ProtectedRoute><AppointmentLogsPage /></ProtectedRoute>} />
        <Route path="/reschedule-appointment/:companyId" element={<ProtectedRoute><ReschedulePage /></ProtectedRoute>} />
        <Route path="/manage-employees/:companyId" element={<ProtectedRoute><ManageEmployees /></ProtectedRoute>} />
        <Route path="/manage-companies/:companyId" element={<ProtectedRoute><ManageCompanies /></ProtectedRoute>} />

        {/* Rotas Protegidas para Usuário */}
        <Route path="/user/home" element={<ProtectedRoute><UserMainPage /></ProtectedRoute>} />
        <Route path="/service/:serviceId" element={<ProtectedRoute><ServicePage /></ProtectedRoute>} />
        <Route path="/user/settings" element={<ProtectedRoute><UserSettings /></ProtectedRoute>} />
        <Route path="/user/appointments" element={<ProtectedRoute><UserAppointmentsPage /></ProtectedRoute>} />
        <Route path="/logout" element={<ProtectedRoute><h1>Logout</h1></ProtectedRoute>} />

        {/* Rota Protegida para Admin */}
        <Route path="/admin" element={<ProtectedRoute requiredRole={"admin"}><h1>Admin Dashboard</h1></ProtectedRoute>} />
        
        {/* Rotas de Erro */}
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;